/*analytics mixin: have route to feedAnalyticsEdit */

//actions
import { GET_TRUST, TO_START_CHART, SET_PENDING } from "../../store/actions/analytics";

export const analytics = {
  computed: {
    isEdit() {
      return this.$route.meta.singlePage;
    },
    pending() {
      return this.$store.getters.pending(this.name);
    },
    data() {
      return this.$store.getters.chartData(this.name);
    },
    dataEmpty() {
      return this.$store.getters.dataEmpty(this.name);
    },
    chartMethod() {
      return this.$store.getters.chartMethod(this.name);
    }
  },
  methods: {
    editChart() {
      this.$router.push({
        name: 'feedAnalyticsEdit',
        params: {
          chart: this.name
        }
      });
    },
    onSave() {
      this.saveChart = true;
    },
    closeChart() {
      history.back();
      setTimeout(() => {document.getElementById("tab-common").click()}, 500)
    },
    handleSaved() {
      this.$store.commit(SET_PENDING, {chart: this.name, pending: false});
      this.saveChart = false;
    },
    handleSave() {
      this.$store.commit(SET_PENDING, {chart: this.name, pending: true});
    }
  },
  destroyed() {
    this.$store.dispatch(TO_START_CHART, {chart: this.name});
  }
};
